import { render } from "./WagonSection.vue?vue&type=template&id=4d8cf866"
import script from "./WagonSection.vue?vue&type=script&lang=js"
export * from "./WagonSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__